import { getFormattedRate, getFormattedRatePerMile } from 'core/presenters/loadPresenter'
import { formatDescription, formatFacilityName, formatZip } from 'core/presenters/stopPresenter'
import { ShipperInformation } from 'core/ui/components/shipper/ShipperInformation'
import { StopsTimeline } from 'core/ui/components/stop/StopsTimeline'

import { LoadDeadline } from './LoadDeadline'
import { LoadRate } from './LoadRate'
import { type TenderCardProps } from './TenderCard'
import {
  CardWrapper,
  DeadlineWrapper,
  MobileBodyWrapper,
  MobileShipperRateWrapper,
} from './TenderCard.styles'
import { TenderConfirmation, TenderAnalyticsContext } from './TenderConfirmation'

export function TenderCardMobile({ disabled = false, load, onAccept, onReject }: TenderCardProps) {
  const { shipper, stops } = load

  return (
    <CardWrapper data-testid="tender-card">
      <DeadlineWrapper>
        <LoadDeadline load={load} />
      </DeadlineWrapper>
      <MobileBodyWrapper>
        <StopsTimeline
          data-testid="tender-card-lane-information"
          stops={stops}
          titleFormatter={formatDescription}
          superTitleFormatter={formatFacilityName}
          subTitleFormatter={formatZip}
          compact
          tags
        />
        <MobileShipperRateWrapper data-testid="tender-card-extra-information">
          {shipper && (
            <ShipperInformation
              companyName={`${shipper.companyName}`}
              logo={shipper?.logoUrl}
              showContactInfo={false}
              data-testid="tender-card-shipper-information"
            />
          )}
          <LoadRate
            rate={getFormattedRate(load)}
            ratePerMile={getFormattedRatePerMile(load)}
            providerRateId={load.providerRateId}
            data-testid="tender-card-load-rate"
          />
        </MobileShipperRateWrapper>
        <TenderConfirmation
          context={TenderAnalyticsContext.LoadBoard}
          disabled={disabled}
          load={load}
          onAccept={onAccept}
          onReject={onReject}
        />
      </MobileBodyWrapper>
    </CardWrapper>
  )
}
